module.exports = __webpack_public_path__ + "img/l22_phone.d49aa57a.jpg";